<template>
  <div class="home">
    <additional-info :consumer-id="loadedId" v-if="consumerLoaded"></additional-info>
    <pre-script-overlay :overlayType="'launch'"></pre-script-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AdditionalInfo from '../components/AdditionalInfo.vue'
import PreScriptOverlay from '../components/PreScriptOverlay.vue'

export default {
  name: 'Consumer',
  props: ['consumerId', 'isnew', 'prepop', 'portalCode'],
  components: {
    AdditionalInfo,
    PreScriptOverlay
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    create (code) {
      if (code && this.isnew) {
        var prepop = this.prepop ?? {}
        this.createConsumer({
          prepop,
          portalCode: code
        })
      }
    },
    ...mapActions({
      createConsumer: 'consumer/createConsumer',
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  computed: {
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      consumerErrors: state => state.consumer.consumerErrors
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded'
    })
  },
  mounted () {
    if (!this.isnew && this.consumerId) {
      this.load(this.consumerId)
    } else if (this.portalCode) {
      this.create(this.portalCode)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    },
    portalCode (code) {
      this.create(code)
    },
    loadedId (newId) {
      if (this.consumerLoaded && this.isnew) {
        this.$router.push(`/consumer/${newId}/additional-information/new`)
      }
    },
    consumerErrors (errors) {
      if (errors.length > 0 && this.loadedId < 1) {
        this.$router.push('/consumer/invalid-portal')
      }
    }
  }
}
</script>
